import { AgentId, agentProvider } from "@/constants/agents";
import { useState } from "react";
import {
  ConnectProviderDialog,
  MODEL_PROVIDERS,
} from "./ConnectProviderDialog";

/** Above the composer's popovers, which the Connect buttons live in. */
const COMPOSER_DIALOG_Z = "z-[10020]";

/**
 * Opens the Settings connect dialog on a subscription agent's provider. The dialog element is
 * the host's to render; `onConnected` runs once the credential is stored.
 */
export function useAgentConnect(onConnected?: (agent: AgentId) => void) {
  const [connecting, setConnecting] = useState<AgentId>();
  const provider = MODEL_PROVIDERS.find(
    (p) => p.id === (connecting && agentProvider(connecting)),
  );

  return {
    openConnect: (agent: AgentId) => setConnecting(agent),
    dialog: provider ? (
      <ConnectProviderDialog
        open
        provider={provider}
        className={COMPOSER_DIALOG_Z}
        onOpenChange={(open) => {
          if (!open) setConnecting(undefined);
        }}
        onConnected={() => connecting && onConnected?.(connecting)}
      />
    ) : null,
  };
}
